var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1951 3.75H6.36716C4.95366 3.75 3.82031 4.8625 3.82031 6.25V11.25H6.36716V6.25H24.1951V23.75H6.36716V18.75H3.82031V23.75C3.82031 24.413 4.08864 25.0489 4.56627 25.5178C5.0439 25.9866 5.6917 26.25 6.36716 26.25H24.1951C24.8706 26.25 25.5184 25.9866 25.996 25.5178C26.4737 25.0489 26.742 24.413 26.742 23.75V6.25C26.742 5.58696 26.4737 4.95107 25.996 4.48223C25.5184 4.01339 24.8706 3.75 24.1951 3.75ZM12.8362 19.475L14.6444 21.25L21.0116 15L14.6444 8.75L12.8362 10.5125L16.1343 13.75H3.82031V16.25H16.1343L12.8362 19.475Z",
    fill: "#E74B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSignOut);
export default __webpack_public_path__ + "static/media/adminSignOut.cecc13795ac1922e544af129eb943777.svg";
export { ForwardRef as ReactComponent };